import { render, staticRenderFns } from "./CouponDetail.vue?vue&type=template&id=c95e56ce&scoped=true&lang=pug&"
import script from "./CouponDetail.vue?vue&type=script&lang=ts&"
export * from "./CouponDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CouponDetail.vue?vue&type=style&index=0&id=c95e56ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95e56ce",
  null
  
)

export default component.exports